import { createAction, props } from '@ngrx/store';

// Action for loading data
export const loadDashboardData = createAction(
    '[Dashboard] Load Data'
);

// Action for successful data loading
export const loadDashboardDataSuccess = createAction(
    '[Dashboard] Load Data Success',
    props<{ data: any }>() // Replace 'any' with the appropriate type for your data
);

// Action for failed data loading
export const loadDashboardDataFailure = createAction(
    '[Dashboard] Load Data Failure',
    props<{ error: any }>() // Replace 'any' with the appropriate type for your error
);